// Tracks only privacy-safe interaction data through the Application Insights web SDK.
export function setupTelemetry(appInsights, router) {
  if (!appInsights) return () => {}
  let lastScrollTime = 0
  const route = () => router?.currentRoute?.value?.fullPath || window.location.pathname
  const trackClick = event => {
    const element = event.target?.closest?.('[data-analytics]') || event.target
    appInsights.trackEvent({ name: 'ui_click', properties: { analytics: element?.getAttribute?.('data-analytics'), tag: element?.tagName?.toLowerCase(), route: route() } })
  }
  const trackScroll = () => {
    if (Date.now() - lastScrollTime < 1000) return
    lastScrollTime = Date.now()
    const max = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight
    appInsights.trackEvent({ name: 'ui_scroll', properties: { percent: max > 0 ? Math.round(window.scrollY / max * 100) : 0, route: route() } })
  }
  document.addEventListener('click', trackClick, { capture: true })
  window.addEventListener('scroll', trackScroll, { passive: true })
  appInsights.trackEvent({ name: 'session_start', properties: { route: route() } })
  return () => { document.removeEventListener('click', trackClick, { capture: true }); window.removeEventListener('scroll', trackScroll) }
}
